module.exports = __webpack_public_path__ + "img/logo.63f8af82.png";